// @ts-check
/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';
import ProductPrice from './ProductPrice/ProductPrice';

export default function ProductHeaderPrice({
  pricing,
  showMorePricingInfo,
  ...rest
}) {
  if (!ProductPrice.hasContent(pricing)) return null;
  return (
    <Text variant="smallest" sx={{ paddingLeft: 1, marginLeft: 3 }} {...rest}>
      <ProductPrice
        pricing={pricing}
        showMorePricingInfo={showMorePricingInfo}
        prependPriceType={true}
      />
    </Text>
  );
}
